import React from "react";

import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import TeacherList from "../../components/TeacherList";

const Teacher: React.FC = () => {
  return (
    <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Teachers"></CardHeader>
          <CardContent>
            <TeacherList></TeacherList>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Teacher;
